/**
 * Copyright (c) 2019-present.
 * All rights reserved.
 *
 * @author link-all
 *
 * @file SuspenseHolder
 */

import React, { CSSProperties } from 'react';

// const style: CSSProperties = {
//     height: '100%',
//     backgroundColor: 'rgba(255,255,255,0.35)',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center'
// };
const style: CSSProperties = {
    position: 'static',
    display: 'inline-block',
    opacity: 1,
};

export interface IPropsLoading {
    style?: CSSProperties;
}
// <div className={ '___link-all-loading_icon' } style={ Object.assign({}, style, props.style) } />
export function Loading(props: IPropsLoading): React.ReactElement {
    return (
        <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
             className="template-loading-icon">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M34.1393 10.0444C31.0046 7.76697 27.1945 6.61117 23.3228 6.76329C19.4511 6.91541 15.7434 8.36659 12.797 10.883C9.85072 13.3994 7.83739 16.8345 7.08148 20.6347C6.32557 24.4349 6.8711 28.379 8.63017 31.8313C10.3892 35.2837 13.2594 38.0433 16.7781 39.6655C20.2969 41.2876 24.2593 41.6779 28.027 40.7734C31.7946 39.8688 35.148 37.7222 37.5467 34.6794C39.9455 31.6365 41.25 27.8747 41.25 24C41.25 22.7574 42.2574 21.75 43.5 21.75C44.7427 21.75 45.75 22.7574 45.75 24C45.75 28.8855 44.1052 33.6286 41.0807 37.4653C38.0561 41.3019 33.8279 44.0085 29.0775 45.149C24.327 46.2895 19.3309 45.7975 14.8942 43.7521C10.4575 41.7068 6.83859 38.2273 4.62064 33.8743C2.40268 29.5213 1.71484 24.5484 2.66795 19.7568C3.62105 14.9652 6.1596 10.634 9.87453 7.46117C13.5895 4.28831 18.2644 2.45857 23.1461 2.26676C28.0278 2.07496 32.8319 3.53227 36.7844 6.40387C37.7897 7.13428 38.0125 8.54136 37.2821 9.54668C36.5517 10.552 35.1446 10.7749 34.1393 10.0444Z"
                  fill="#326BFB"/>
        </svg>
    );
}

export default Loading;
